import { IFile } from 'types/file'
import { ITender } from 'types/tender/index'
import { IModificationInfo } from 'types/creationDetails'

export enum ETenderRequirementType {
  GENERAL = 'GENERAL',
  SPECIAL = 'SPECIAL',
}

export interface ITenderRequirement extends IModificationInfo {
  id: string
  type: ETenderRequirementType
  order: number
  extraInfo: string
  extraFile: IFile
  tender: ITender
}
